module.exports = __webpack_public_path__ + "assets/img/1_1718_big.4ce048a8.jpg";